// var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
// var s = require('./languageCommon')
// console.log(s)
var languageType = require('./languageCommon.js')
var language = localStorage.getItem('language') || 'zh-CN'
require('./sensorsdata.js')
require('../home.css');
require('../en.css')
if(language=='zh-CN'){
    $('body').removeClass('en')
}else{
    $('body').addClass('en')
}
$('.commonflowerTravel').addClass('select');
$('.reservation').css('color','white');
var flagIndex=0;
var flag=0;
$('.reservationCode .close ,.reservationCode .guanbi').on('click',function () {
    $('.reservationCode').fadeOut(300);
    $('.reservation').css('opacity',1);
});


$('.language').on('mouseover',function() {
    $(".choicelanguage").show();
}).on('mouseout',function() {
    $(".choicelanguage").hide();
})
$('.choicelanguage a').eq(0).on('click',function(){
    // debugger
    console.log(window.location)
    window.location.href = window.location.origin+window.location.pathname+'?locale=zh-CN'
    localStorage.setItem('language','zh-CN')
    //window.location.reload();
})
$('.choicelanguage a').eq(1).on('click',function(){
    localStorage.setItem('language','USA');
    window.location.href = window.location.origin+window.location.pathname+'?locale=USA'
     
    //window.location.reload();
})
$('.choicelanguage a').eq(2).on('click',function(){
 localStorage.setItem('language','JP');
window.location.href = window.location.origin+window.location.pathname+'?locale=JP'
    //window.location.reload();
})
$('.choicelanguage a').eq(3).on('click',function(){
   localStorage.setItem('language','KO');
window.location.href = window.location.origin+window.location.pathname+'?locale=KO'
    //window.location.reload();
})
$('.choicelanguage a').eq(4).on('click',function(){
   localStorage.setItem('language','TH');
window.location.href = window.location.origin+window.location.pathname+'?locale=TH'
    //window.location.reload();
})
$('.choicelanguage a').eq(5).on('click',function(){
    localStorage.setItem('language','TH');
 window.location.href = window.location.origin+window.location.pathname+'?locale=YH'
     //window.location.reload();
 })
$(".about1").on('mouseover',function() {
    $(".aboutLv").show();
})
$(".about1").on('mouseout',function() {
    $(".aboutLv").hide();
})
$(".brand1").on('mouseover',function() {
    $(".choiceBrand").show();
}).on('mouseout',function() {
    $(".choiceBrand").hide();
})

var width = 198;

var width1 = $('.floralTrip_container_header').width();
flagIndex=width1-width;


$('.floralTrip_container_header_conainer div').css({width:width});
$('.floralTrip_container_header_conainer').css({width:7*width});
$(window).resize(function () {
    //当浏览器大小变化时
    width1 = $('.floralTrip_container_header').width();
    flagIndex = width1 - width;

});
var step=1;
var $headerContainer=$('.floralTrip_container_header_conainer');
var timer=setInterval(move,3000);
var moveflag = 0;
moveflag = -flagIndex / 2;
$headerContainer.css({ 'left': -width - moveflag});
function move(n) {
    moveflag=-flagIndex/2;
    step++;
    n!=undefined?step=n:null;
    if(step==5){
        $headerContainer.css('left', -width- moveflag);
        step=2;
    }
    $('.floralTrip_banner li').eq(step-1).addClass('floralTrip_banner_select').siblings().removeClass('floralTrip_banner_select');
    if(step==4){
        $('.floralTrip_banner li').eq(0).addClass('floralTrip_banner_select').siblings().removeClass('floralTrip_banner_select');
    }
    $headerContainer.stop(false,true).animate({left:-step*width-moveflag},500,'linear',function () {

    });
}
$('.floralTrip_container_header').on('mouseover',function () {
    clearInterval(timer);
});
$('.floralTrip_container_header').on('mouseout',function () {
    timer=setInterval(move,3500);
});
$('.floralTrip_banner li').on('click',function () {
    step=$('.floralTrip_banner li').index($(this))+1;
    $('.floralTrip_banner li').eq(step-1).addClass('floralTrip_banner_select').siblings().removeClass('floralTrip_banner_select');
    $headerContainer.stop(false, true).css({ left: -step * width + -moveflag});
});





/** WEBPACK FOOTER **
 ** ./src/js/floralTrip.js
 **/